import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import TempletPreview1 from "./TemplatePreview1";
import TempletPreview2 from "./TemplatePreview2";
import TempletPreview3 from "./TemplatePreview3";
import { getCitiesByUserId } from "../../Services/citiesApi";
import { createTerminal, editTerminalById } from "../../Services/terminal";
import Select from "react-tailwindcss-select";
import { validateURL } from "../util/linkValidation";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const orientationOption = [
    { label: "Vertical", value: "vertical" },
    { label: "horizontal", value: "horizontal" }
];
const NewTerminalForm = ({
    open,
    close,
    submitRequest,
    isEditing = false,
    terminalData
}) => {
    const [formData, setFormData] = useState({
        name: '',
        cityId: null,
        latitude: '',
        longitude: '',
        link: '',
        status: 'active',
        template: 'A',
        orientation: null,
    })
    const [errors, setErrors] = useState({});
    const [citiesList, setCities] = useState([]);
    const [isOpenTemplate, setIsOpenTemplate] = useState(null);
    const [success, setSuccess] = useState(false);
    const [isvalidMapLink, setIsValidMapLink] = useState(true);
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState('');

    const { isAdmin } = location.state || {};
    const { t } = useTranslation();
    function handleSucess() {
        setSuccess(true);
        setTimeout(() => {
            setSuccess(false);
        }, 10000);
    }

    function handleFailure(message) {
        setErrorMessage(message); // You can create a state like setErrorMessage
        setTimeout(() => {
            setErrorMessage('');
        }, 10000);
    }

    const handleFormData = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }))
    }
    const validateFormData = () => {
        const errorsData = {};

        if (!formData.name.trim()) {
            errorsData.name = 'Name is required';
        }

        if (!formData.cityId?.value) {
            errorsData.cityId = 'City ID is required';
        }
        if (!formData.orientation?.value) {
            errorsData.orientation = 'Orientation is required';
        }

        return errorsData;
    };
    const handleMapLink = (link) => {
        if (validateURL(link)) {
            handleFormData("link", link);
            setIsValidMapLink(true);
        } else {
            setIsValidMapLink(false);
            handleFormData("link", link);
            setErrors((prev) => ({ ...prev, link: 'Invalid Map Link' }));
        }
    }
    const handleSubmitRequest = async () => {
        try {
            const errorsData = validateFormData();
            setErrors(errorsData);

            if (Object.keys(errorsData).length === 0) {

                if (isEditing) {
                    let params = {
                        name: formData.name,
                        mapLink: formData.link,
                        template: formData.template ?? 'A',
                        cityId: formData.cityId.value,
                        orientation: formData.orientation.value
                    }
                    if (formData.latitude) {
                        params.latitude = formData.latitude
                    }
                    if (formData.longitude) {
                        params.longitude = formData.longitude
                    }

                    await editTerminalById(formData.terminalId, params);
                } else {

                    await createTerminal({ ...formData, cityId: formData.cityId.value, orientation: formData?.orientation?.value, mapLink: formData.link });
                    setFormData({
                        name: '',
                        cityId: null,
                        latitude: '',
                        longitude: '',
                        link: '',
                        status: 'active',
                        template: 'A',
                        orientation: null
                    })
                    close();
                }
                handleSucess();
                submitRequest();
            }
        } catch (e) {
            handleFailure(e?.response?.data?.message || 'Something went wrong, please try again later.');
        }
    }

    useEffect(() => {
        getCitiesByUserId(null).then((citiesResponse) => {
            setCities(citiesResponse.data.data.map((city) => ({ label: city.name, value: city.id })));
        });
    }, [])
    useEffect(() => {
        if (isEditing && terminalData.terminalId && citiesList.length) {
            setFormData({ ...terminalData, cityId: citiesList.find((city) => city.value === terminalData.cityId), orientation: orientationOption.find((val) => val.value === terminalData?.orientation) })
        }
    }, [isEditing, terminalData, citiesList])
    if (!open) return;
    return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">{isEditing ? t("edit") : t("CategoryCreateNew")} {t("terminal")}</h3>
            </div>
            <div className="p-6 space-y-6 overflow-y-auto max-h-[75vh]">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Terminal {t("Name")}<span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-button text-sm"
                        value={formData.name}
                        onChange={(e) => handleFormData("name", e.target.value)}
                        placeholder={t("enter_terminal_name")}
                    />
                    {errors?.name && <p className="text-sm text-red-500">{errors.email}</p>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t("select_city")}<span className="text-red-700">*</span></label>
                    <Select
                        primaryColor="indigo"
                        options={citiesList}
                        placeholder={t("select")}
                        value={formData.cityId}
                        onChange={(e) => handleFormData("cityId", e)}
                    />
                    {errors?.cityId && <p className="text-sm text-red-500">{errors.email}</p>}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">{t("map_link")}</label>
                        <input type="url" value={formData?.link} placeholder={`https://${t("maps")}...`} className="w-full px-4 py-2 border border-gray-300 rounded-button text-sm" onChange={(e) => handleMapLink(e.target.value)} />
                        {!isvalidMapLink && (
                            <p className="text-red-500 text-sm mt-1">{t("validurl")}</p>
                        )}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">{t("select_orientation")}<span className="text-red-700">*</span></label>
                        <Select
                            primaryColor="indigo"
                            classNames={"text-black"}
                            options={orientationOption}
                            placeholder={t("select")}
                            value={formData.orientation}
                            onChange={(selectedOption) => handleFormData("orientation", selectedOption)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">{t("latitude")}</label>
                        <input type="text" placeholder="52.52" className="w-full px-4 py-2 border border-gray-300 rounded-button text-sm" value={formData.latitude} onChange={({ target: { value } }) => {
                            handleFormData("latitude", value)
                        }} />
                        {errors?.latitude && <p className="text-sm text-red-500">{errors.latitude}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">{t("longitude")}</label>
                        <input type="text" placeholder="13.405" className="w-full px-4 py-2 border border-gray-300 rounded-button text-sm" value={formData.longitude} onChange={({ target: { value } }) => {
                            handleFormData("longitude", value)
                        }} />
                        {errors?.longitude && <p className="text-sm text-red-500">{errors.longitude}</p>}
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{t("assign_template")}<span className="text-red-700">*</span></label>
                    <ul className="flex gap-6 items-center">
                        {[{ label: "Template A", value: "A" }, { label: "Template B", value: "B" }, { label: "Template C", value: "C" }].map((temp, index) => (
                            <li key={index} className="flex items-center gap-3">
                                <input
                                    type="radio"
                                    name="language"
                                    value={temp.value}
                                    checked={formData.template === temp.value}
                                    className="form-radio focus:ring-primary cursor-pointer"
                                    onClick={(e) => handleFormData("template", e.target.value)}
                                />
                                <div className="flex flex-col">
                                    <label className="text-sm cursor-pointer">{temp.label}</label>
                                    <span className="font-bold text-xs text-blue-600 underline cursor-pointer" onClick={() => setIsOpenTemplate(temp.value)}>{t("view_preview")}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                {success && <p className="text-sm text-green-500">{t("terminal_success")}</p>}
                {errorMessage && <p className="text-sm text-red-500">{t("terminal_failure", { message: errorMessage })}
                </p>}


                <div className="flex justify-end space-x-3 pt-4">
                    <button
                        onClick={close}
                        className="px-4 py-2 border border-gray-300 rounded text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                    >
                        {t("cancel")}
                    </button>
                    <button
                        onClick={() => {
                            handleSubmitRequest();
                        }}
                        disabled={!!Object.keys(validateFormData()).length}
                        className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-medium hover:bg-indigo-600 disabled:bg-gray-100 disabled:text-gray-400 disabled:font-black disabled:cursor-not-allowed"
                    >
                        {isEditing ? t("edit") : t("add")} {t("terminal")}
                    </button>
                </div>
            </div>
        </div>
        {(isOpenTemplate === "A") && <TempletPreview1 isopen={isOpenTemplate} setIsOpen={setIsOpenTemplate} orientation={formData.orientation?.value} />}
        {(isOpenTemplate === "B") && <TempletPreview2 isopen={isOpenTemplate} setIsOpen={setIsOpenTemplate} orientation={formData.orientation?.value} />}
        {(isOpenTemplate === "C") && <TempletPreview3 isopen={isOpenTemplate} setIsOpen={setIsOpenTemplate} />}
    </div>
};

NewTerminalForm.propTypes = {
    open: PropTypes.boolean,
    close: PropTypes.string.isRequired,
    submitRequest: () => { }
};

export default NewTerminalForm;
